"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var domainConfigurationChoice = _ref.domainConfigurationChoice,
      onChange = _ref.onChange,
      suggestedDomain = _ref.suggestedDomain;
  return _react2.default.createElement(
    "div",
    { id: "fc-checkout-domain-options-form" },
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "button",
        {
          className: "fc-checkout-domain-option",
          style: { border: domainConfigurationChoice === 'subdomain' && 'solid medium #C24242' },
          onClick: function onClick() {
            return onChange('subdomain');
          }
        },
        _react2.default.createElement(
          "div",
          null,
          "Free Website"
        ),
        _react2.default.createElement(
          "div",
          null,
          "I want to keep this website at ",
          _react2.default.createElement(
            "span",
            null,
            suggestedDomain,
            ".fishrmn.com"
          ),
          " for free."
        )
      ),
      _react2.default.createElement(
        "button",
        {
          className: "fc-checkout-domain-option",
          style: { border: domainConfigurationChoice === 'newDomain' && 'solid medium #C24242' },
          onClick: function onClick() {
            return onChange('newDomain');
          }
        },
        _react2.default.createElement(
          "div",
          null,
          "Custom Domain"
        ),
        _react2.default.createElement(
          "div",
          null,
          "I want to connect this website to a custom URL and get access to site changes/upgrades."
        )
      )
    )
  );
};